import { useResizeEffect } from "@pp/core/src/hooks/useResizeEffect";
import { ReactElement, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"

interface TextfitProps {
    children: string,
    offsetWidth?: number,
    wordWrap?: boolean,
    fontFamily?: string
}
export const Textfit = ({ children, offsetWidth = 0, wordWrap = false, fontFamily = 'Poppins' }: TextfitProps): ReactElement => {
    const [fs, setFs] = useState<number>(18);
    const ref = useRef<HTMLDivElement>(null);
    const parentElement = useRef<any>(null);
    const getTextWidth = (text: string, font: string): number => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        if(!context) return 0;
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
    };
    const updateFontSize= useCallback(() => {
        if(!ref.current) return
        const parentDefaultfontSize = parseInt(getComputedStyle(parentElement.current).getPropertyValue('font-size'));
        const widthAvailableToDisplay = parentElement.current.clientWidth - offsetWidth;
        const fontSize = `${parentDefaultfontSize}px ${fontFamily}`;
        const contentWidth = getTextWidth(children, fontSize);
        const heightAvailableToDisplay = parentElement.current.clientHeight;
        const contentHeight = ref.current.clientHeight;
        const noOfWords = children.split(' ').length;
        setFs(() => {
            // when content doesn't fit in the required section
            if(contentWidth > widthAvailableToDisplay) {
                // providing flexiblility for the words to wrap up by param only if words > 1 else normal case
                if(wordWrap && noOfWords > 1){
                    //reducing the font-size if wrapped words overflows it's parent's height
                    if(contentHeight && contentHeight > heightAvailableToDisplay){
                        return Math.floor((Math.floor((heightAvailableToDisplay / contentHeight) * 100) / 100) * parentDefaultfontSize);
                    }
                    //To-Do: if any of the words overflowing the requires width

                    return parentDefaultfontSize;
                }
                return Math.floor((Math.floor((widthAvailableToDisplay / contentWidth) * 100) / 100) * parentDefaultfontSize);
            }   
            return parentDefaultfontSize;
        });
    },[setFs, getTextWidth])

    //Settings up the default font-size
    useEffect(() => {
        if (!ref.current) return;
        parentElement.current = ref.current.parentElement;
        setFs(() => {
            return parseInt(getComputedStyle(parentElement.current).getPropertyValue('font-size'))
        })
        updateFontSize();
    }, [])

    //Obersving the changes to the element if it is rerendered
    useLayoutEffect(() => {
        if(!parentElement.current || !ref.current) return;
        updateFontSize();
    })

    //Responding to the resize event
    useResizeEffect(
        useCallback(() => {
            if(!parentElement.current || !ref.current) return;
            updateFontSize();
        }, [])
    )
    return <div ref={ref} style={{ fontSize: `${fs}px`, display: 'inline-block', whiteSpace: wordWrap ? 'pre-wrap':'normal', lineHeight: '100%'}}>
        {children}
    </div>
}